const dsAccount = (($) => {

    const address_form = 'div#address_form',
        address_list = 'div#address-list',
        address_input = 'input#address_input',
        input_address_id = 'input#address_id',
        input_knock = 'input#knock',
        input_sms = 'input#sms',
        sms_delivered = 'input#sms_delivered',
        email_delivered = 'input#email_delivered',
        knock_sms = `${input_knock}, ${input_sms}, ${sms_delivered}, ${email_delivered}`,
        address_type = address_form + ' select#type',
        address_action = $(input_address_id).length && $(input_address_id).val().length > 0 ? 'edit' : 'add',
        login_form = 'form#form_login',
        payments_div = 'div#payments',
        order_history_div = 'div.order-history-item',
        list_edit = 'a.shop-list-edit',
        list_done = 'a.shop-list-done',
        list_remove = 'img.remove-product',
        voucher_form = 'div#gift_voucher_form',
        fd_form = 'div#free_delivery_form',
        modal_edit = 'div.modal[data-type="edit-order"]',
        modal_cancel = 'div.modal[data-type="cancel-order"]',
        modal_reorder = 'div.modal[data-type="reorder"]',
        modal_add = 'div.modal[data-type="add-to-order"]',
        rewards_input = 'input#rewards',
        gv_minimum = 25;
    let address = { verified : 1 },
        saved_address = '',
        order = {},
        reorder = {},
        from = '',
        gv_submit = false,
        incrementTimer;

    function setMessage(el, message = '', type = 'error') {
        $(el).removeClass('error-msg success-msg');
        !message.length ? $(el).addClass('hide') : $(el).removeClass('hide').addClass(type + '-msg');
        $(el).html(message);
    }

    /* ADDRESS */
    function setAddress(data) {
        address = data;
        setFreshDefaults(data.suburb, data.postcode, $(address_type).val());
    }

    function setFreshDefaults(suburb, postcode, type) {
        if (suburb !== undefined && postcode !== undefined) {
            getFresh(suburb, postcode).done(function (fresh) {
                address.fresh = parseInt(fresh);
                setFresh(fresh, type);
            });
        }
    }

    function getFresh(suburb, postcode) {
        return $.ajax({
            url: dsUtilities.urlAddress() + '/get_fresh',
            type: 'post',
            data: { suburb: suburb, postcode: postcode },
            dataType: 'json'
        });
    }

    function setFresh(fresh, type) {
        if (!isFresh(fresh)) {
            $(knock_sms).prop('readonly', true).prop('checked', false);
        } else {
            $(knock_sms).prop('readonly', false);
            if (address_action === 'add') {
                $(knock_sms).prop('checked', true);
            }
            if (['Security Apartment', 'Business Address', 'School'].includes(type)) {
                $(input_knock).prop('readonly', true).prop('checked', true);
            }
        }
    }

    function isFresh(fresh) {
        return fresh > 0 && fresh < 6;
    }

    function setSavedAddress(address) {
        saved_address = address;
    }

    function getSavedAddress() {
        return saved_address;
    }

    function getAddressId(el) {
        return $(el).closest('div.item').attr('data-id');
    }

    function saveAddress() {
        message(address_form);
        address.address_id = $(input_address_id).val();
        if (address.verified) {
            address.street_number = (address.street_number_1 === null ? '' : (address.street_number_1 + (address.street_number_2 !== null ? '-' + address.street_number_2 : '')));
        }
        if (!address.verified) {
            address.state = dsUtilities.zone_to_state(address.state);
        }
        dsValidate.validPostcodeData(address).done(function(response) {
            if (!response.success) {
                message(address_form, response.message,'error');
            } else {
                $.ajax({
                    url: dsUtilities.urlAddress() + '/' + address_action,
                    type: 'post',
                    data: { address: address },
                    dataType: 'json',
                    beforeSend: function() {
                        $('div#address_error').addClass('hide').html('');
                    },
                    success: function(response) {
                        if (response.success) {
                            location.href = dsUtilities.urlAddress();
                        }
                        if (doorstep.return_url.length > 0) {
                            location.href = doorstep.return_url + '&address_id=' + response.id;
                        }
                    }
                });
            }
        });
    }

    function message(el, msg = '', type = 'success') {
        $(el + ' #message').removeClass().addClass(!msg.length ? 'hide' : type + '-msg-box').html(msg);
    }

    function validateAddress() {
        message(address_form);
        address.type            = $('select#type').val().trim();
        address.firstname       = $('input#firstname').val().trim();
        address.lastname        = $('input#lastname').val().trim();
        address.mobile          = $('input#mobile').val().replace(/\s/g, '');
        address.company         = $('input#company').val().trim();
        address.level           = $('input#level').val().trim();
        address.address_input   = $('input#address_input').val().trim();
        address.sms_delivered   = $('input#sms_delivered').is(':checked');
        address.email_delivered = $('input#email_delivered').is(':checked');
        if (!address.verified) {
            address.unit          = $('input#unit').val().trim();
            address.state         = $('select#state').val().trim();
            address.suburb        = $('input#suburb').val().trim();
            address.postcode      = $('input#postcode').val().trim();
            address.street_number = $('input#street_number').val().trim();
            address.street_name   = address.street && address.street.length > 0 ? address.street : $('input#street_name').val().trim();
        }
        if ($(input_sms).is(':checked') && address.mobile.length === 0) {
            message(address_form,'Please enter a Mobile number as you have enabled SMS notifications.','error');
        } else if (
            ($(input_sms).is(':checked') && !dsValidate.validMobile(address.mobile)) ||
            (!$(input_sms).is(':checked') && address.mobile.length > 0 && !dsValidate.validMobile(address.mobile))
        ) {
            message(address_form,'Your mobile number does not appear to be valid.','error');
        } else {
            address.instructions = $('textarea#instructions').val().trim();
            address.knock        = $(input_knock).is(':checked');
            address.sms          = $(input_sms).is(':checked');
            address.telephone    = $('input#telephone').val().trim();
            if (!address.verified) {
                const has_unit = address.unit.length > 0,
                    address_line = address.street_number + ' ' + address.street_name;
                address.id                   = '';
                address.longitude            = '';
                address.latitude             = '';
                address.address_finder_id    = '';
                address.canonical_address_id = '';
                address.canonical_address    = '';
                address.address_line_1       = has_unit ? 'Unit ' + address.unit : address_line;
                address.address_line_2       = has_unit ? address_line : '';
            }
            if (address.type !== 'Business Address' && address.type !== 'School') {
                address.company = '';
                if (address.type !== 'Business Address') {
                    address.level = '';
                }
            }
            if (address.verified && address.canonical_address_id === undefined) {
                message(address_form, 'If your address has not appeared in the address dropdown, please press on the Can\'t Find Your Address option and enter it manually','error');
            } else {
                saveAddress();
            }
        }
    }

    function isValidAddress() {
        let valid = true,
            aValidate = [['type', 'select'], 'firstname', 'lastname'];
        if (address.type === 'Business Address' || address.type === 'School') {
            aValidate.push('company');
        }
        if (!address.verified && (address.type === 'Duplex' || address.type === 'Non-Security Apartment' || address.type === 'Security Apartment' || address.type === 'Townhouse')) {
            aValidate.push('unit');
        }
        if (address.verified) {
            aValidate.push('address_input');
        }
        if (!address.verified) {
            aValidate.push(['state', 'select'], 'suburb', 'postcode', 'street_number', 'street_name');
        }
        dsValidate.checkLength(aValidate, address);
        const address_fields = $(address_form).find('input, select').not('.hide');
        $.each(address_fields, function() {
            if ($(this).hasClass('mandatory')) {
                valid = false;
                return false;
            }
        });
        return valid;
    }

    function showAddressForm(checked) {
        address.verified = checked ? 0 : 1;
        if (checked) {
            $(address_input).val('');
            $('input#manual').attr('checked', true);
            $('div#street_number_street_name, div#suburb_postcode, div#state_none').removeClass('hide');
        } else {
            $('input#manual').attr('checked', false);
            $('div#company_none, div#mobile_telephone, div#level_unit, div#street_number_street_name, div#suburb_postcode, div#state_none').addClass('hide');
        }
        $('span#company_mand').val(address.type === 'Business Address' || address.type === 'School' ? '*' : '');
        $(address_form).find('input, select').removeClass('mandatory');
        $(address_form).find('input#unit, input#street_number, input#street_name');
        changeAddressType($(address_form + ' select#type').val());
    }

    function changeAddressType(type) {
        $('div#level_unit, input#unit, span#unit_mand, span#company_mand, input#level, label#label_level, div#company_none').addClass('hide');
        $(address_form).find('input, select').removeClass('mandatory');
        if (type === 'Business Address') {
            $('input#level, label#label_level, div#company_none, span#company_mand').removeClass('hide');
            if (!address.verified) {
                $('div#level_unit, input#unit').removeClass('hide');
            }
        } else if (type === 'School') {
            $('div#company_none, span#company_mand').removeClass('hide');
        } else if (!address.verified && (type === 'Duplex' || type === 'Non-Security Apartment' || type === 'Security Apartment' || type === 'Townhouse')) {
            $('div#level_unit, span#unit_mand, input#unit').removeClass('hide');
        }
        setFreshDefaults(address.suburb, address.postcode, type);
        $('span#knock-msg, span#sms-msg').html('');
    }

    function deleteAddress(el) {
        $(address_list).find('div.item').each(function () {
            addressListMessage($(this));
        });
        const div = $(el).closest('div.item');
        if (parseInt($(div).attr('data-default'))) {
            addressListMessage(el, 'This is your default address. Please assign a new default address before proceeding.', 'error');
        } else {
            const actions = $(div).find('div.actions');
            $(actions).addClass('hide');
            $.ajax({
                url: dsUtilities.urlAddress() + '/delete',
                type: 'post',
                data: { id: $(div).attr('data-id') },
                dataType: 'json',
                success: function(response) {
                    if (response.success) {
                        addressListMessage(el, response.msg);
                        $(div).fadeOut(2000);
                    } else {
                        addressListMessage(el, response.msg, 'error');
                        $(actions).removeClass('hide');
                    }
                }
            });
        }
    }

    function defaultAddress(el) {
        $(address_list).find('div.item').each(function () {
            addressListMessage($(this));
        });
        const div = $(el).closest('div.item');
        if (parseInt($(div).attr('data-default'))) {
            addressListMessage(el, 'This is already your default address.', 'error');
        } else {
            const actions = $(div).find('div.actions');
            $(actions).addClass('hide');
            $.ajax({
                url: dsUtilities.urlAddress() + '/make_default',
                type: 'post',
                data: { id: $(div).attr('data-id') },
                dataType: 'json',
                success: function(response) {
                    if (response.success) {
                        if (div.index() > 0) {
                            location.reload();
                        }
                    }
                }
            });
        }
    }

    function addressListMessage(el, msg = '', type='success') {
        const div = $(el).closest('div.item').find('p.address-list-message');
        if (!msg.length) {
            $(div).removeClass('address-list-success address-list-error').addClass('hide').html('');
        } else {
            $(div).removeClass('hide') .addClass('address-list-' + type).html(msg);
        }
    }

    function suburbSearch() {
        return {
            lookup : function(request, done) {
                $.ajax({
                    url: dsUtilities.urlAddress() + '/postcode',
                    type: 'get',
                    data: { request: request },
                    dataType: 'json',
                    success: function(response) {
                        if (response!==null) {
                            let suburbs = { suggestions: [] };
                            const results = response.localities.locality instanceof Array ? response.localities.locality : [response.localities.locality];
                            results.forEach(function (item) {
                                suburbs.suggestions.push({ value: item.location + ', ' + item.state + ', ' + item.postcode, data: item.location });
                            });
                            done(suburbs);
                        }
                    }
                });
            },
            minChars : 3,
            onSelect : function (result) {
                const parsed = result.value.split(',').map(function(item) {
                    return item.trim();
                });
                const suburb = parsed[0],
                    postcode = parsed[2];
                $(address_form + ' input#suburb').val(suburb);
                $(address_form + ' select#state').val(dsUtilities.state_to_zone(parsed[1]));
                $(address_form + ' input#postcode').val(postcode);
                setFreshDefaults(suburb, postcode, $(address_type).val());
            }
        };
    }

    /* ACTIVE ORDERS */
    function getOrderHistoryData(el) {
        const div = $(el).closest(order_history_div);
        return {
            'id'      : parseInt($(div).attr('data-id')),
            'type'    : $(div).attr('data-type'),
            'edit'    : parseInt($(div).attr('data-edit')),
            'add'     : parseInt($(div).attr('data-add')),
            'transit' : parseInt($(div).attr('data-transit'))
        }
    }

    function editOrderUrl(cart= 0) {
        if (order.id > 0) {
            if (order.type === 'order') {
                location.href = dsUtilities.urlEdit() + `/edit&order_id=${order.id}&cart=${cart}`
            } else if (order.type === 'recurring') {
                location.href = `index.php?route=account/account/create_recurring&order_id=${order.id}&cart=${cart}`
            }
        }
    }

    function addToCart(el) {
        if ($(el).attr('src') === '/dist/images/add_to_new_order.svg') {
            let product = getOrderProduct(el, true);
            product.quantity_start = parseFloat($(el).closest('div.item').attr('data-quantity'));
            product.date_next = moment(product.date_next, 'YYYY-MM-DD');
            product.date_to = moment(product.date_to, 'YYYY-MM-DD');
            product.date_unlimited = moment(product.date_unlimited, 'YYYY-MM-DD');
            product.run_date = !doorstep.saved_run_date.length ? moment().add(1, 'days').startOf('day') : moment(doorstep.saved_run_date, 'YYYY-MM-DD');
            dsProduct.addToCart(el, product.in_cart, false, product);
            dsUtilities.doModal('fave', `${product.name} added to your box`);
            $(el).attr('src', '/dist/images/add_to_new_order_selected.svg');
        }
    }

    function addToList(el) {
        let product = getOrderProduct(el, true);
        product.quantity_start = parseFloat($(el).closest('div.item').attr('data-quantity'));
        dsList.modalOpen(el, 'product', product);
    }

    function addFavourite(el) {
        const action = $(el).attr('src').endsWith('fav_small.svg') ? 'add' : 'remove';
        dsProduct.addToFav(el, action, getOrderProduct(el, true)).done(function(response) {
            if (!response.error) {
                dsUtilities.doModal('fave', response.message);
                $(el).attr('src', '/dist/images/fav_small' + (action === 'add' ? '_selected.svg' : '.svg'));
            }
        });
    }

    function getOrderProduct(el, get_child = false) {
        const id = parseInt($(el).closest('div.item').attr('data-id'))
        let prod = {};
        doorstep.order_products.forEach(function(product) {
            if (product.id === id) {
                prod = product;
            }
            product.child_products.forEach(function (child) {
                if (child.id === id) {
                    prod = get_child ? child : product;
                }
            });
        });
        return prod;
    }

    /* EDIT */
    $('#form_edit input#subscribe').on('click', function() {
        $("input[name^='newsletters']").attr('checked', $(this).is(':checked'));
    });

    /* SHOPPING LISTS */
    function listEdit() {
        $(list_edit).addClass('hide');
        $(`${list_done}, ${list_remove}`).removeClass('hide');
    }

    function listDone() {
        $(`${list_done}, ${list_remove}`).addClass('hide');
        $(list_edit).removeClass('hide');
    }

    function listItemRemove(el) {
        const div = $(el).closest('div.shopping-list'),
            new_total = (parseFloat($(div).attr('data-total')) - parseFloat($(el).attr('data-total'))).toFixed(2);
        $.ajax({
            url: 'index.php?route=account/shopping_lists/remove_item',
            type: 'post',
            data: { id : parseInt($(el).attr('data-id')) },
            dataType: 'json',
            success: function (response) {
                if (!response.error) {
                    $(el).closest('div.product').remove();
                    $(div).attr('data-total', new_total);
                    $(div).find('div.total-display').html('<strong>Total: $' + new_total + '</strong>');
                }
            }
        });
    }

    /* GIFT VOUCHER */
    function gvValidate() {
        let valid = true, error_message = [];
        const voucher_data = {},
            voucher_fields = $('div#gift_voucher_form').find('input, textarea').not(':checkbox'),
            amount_min = 25,
            amount = 'input#amount',
            amount_val = Number($(amount).val().trim()),
            div_message = 'div#message',
            email_from = 'input#email_from';
        setMessage(div_message);
        $.each(voucher_fields, function() {
            voucher_data[$(this).attr('id')] = $(this).val().trim();
        });
        dsValidate.checkLength(['name_to', ['message', 'textarea'], 'amount'], voucher_data);
        dsValidate.checkChecked(['non_refundable']);
        if (!dsValidate.validEmail($(email_from).val().trim())) {
            error_message.push('Email address is not valid.');
            $(email_from).addClass('mandatory');
        } else {
            $(email_from).removeClass('mandatory');
        }
        if (isNaN(amount_val) || (!isNaN(amount_val) && amount_val < amount_min)) {
            error_message.push(`Enter amounts over $${gv_minimum}.`);
            $(amount).addClass('mandatory')
        } else {
            $(amount).removeClass('mandatory')
        }
        if ($('input#non_refundable').hasClass('mandatory')) {
            error_message.push('Please ensure the "I understand that Gift Vouchers are unrefundable" checkbox is selected.');
        }
        voucher_fields.push($('input#non_refundable'))
        $.each(voucher_fields, function() {
            if ($(this).hasClass('mandatory') && valid) {
                valid = false;
            }
        });
        if (error_message.length > 0) {
            error_message.unshift('Please ensure all fields are completed.');
            setMessage(div_message, error_message.join('<br>'))

        }
        return valid;
    }

    /* FREE DELIVERY */
    function fdValidate() {
        let valid = true, error_message = [];
        const amount = Number($('input#amount').val().trim()),
            plan = 'select#plan',
            div_message = 'div#message';
        setMessage(div_message);
        if (!amount) {
            valid = false;
            $(plan).addClass('mandatory');
            error_message.push('Please select a free delivery option before proceeding.');
        } else {
            $(plan).removeClass('mandatory');
        }
        dsValidate.checkChecked(['non_refundable']);
        if ($('input#non_refundable').hasClass('mandatory')) {
            valid = false;
            error_message.push('Please ensure the "I understand that this Free Delivery plan is unrefundable" checkbox is selected.');
        }
        if (error_message.length > 0) {
            setMessage(div_message, error_message.join('<br>'))

        }
        return valid;
    }

    /* BILLING */
    function invoiceEmail(el) {
        $.ajax({
            url: 'index.php?route=account/billing/email_invoice',
            type: 'post',
            data: { id : $(el).attr('data-id') },
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    $('div.invoice-modal').removeClass('hide');
                }
            }
        });
    }

    /* ACCOUNT SETTINGS */
    function sendReferralEmail() {
        const email = $('input#referral_email').val().trim(),
            msg_div = 'div#referral_msg';
        $(msg_div).html('').addClass('hide');
        if (!dsValidate.validEmail(email)) {
            $(msg_div).html('This looks like an invalid email address.').removeClass('hide success-msg').addClass('error-msg');
        } else {
            $.ajax({
                url: 'index.php?route=account/edit/referral_send',
                type: 'post',
                data: { email : email },
                dataType: 'json',
                success: function (response) {
                    $(msg_div).html(response.message).removeClass('hide success-msg error-msg').addClass((response.success ? 'success' : 'error') + '-msg');
                }
            });
        }
    }
    function deleteAccount() {
        $.ajax({
            url: 'index.php?route=account/edit/delete',
            type: 'post',
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    location.href = dsUtilities.urlLogout('delete');
                }
            }
        });
    }

    /* REWARDS */
    function rewardModal() {
        $('div.modal[data-type="rewards-' + ($(rewards_input).is(':checked') ? 'enrol' : 'resign') + '"]').removeClass('hide');
    }

    function rewardsEnrol() {
        $.ajax({
            url: 'index.php?route=account/edit/rewards_enrol',
            type: 'post',
            dataType: 'json',
            beforeSend: function() {
                $(rewards_input).attr('disabled', true);
            },
            success: function(response) {
                $(rewards_input).attr('disabled', false);
                $('div.modal').addClass('hide');
                if (response.success) {
                    $(rewards_input).prop('checked', true);
                }
            }
        })
    }

    function rewardsResign() {
        $.ajax({
            url: 'index.php?route=account/edit/rewards_resign',
            type: 'post',
            dataType: 'json',
            beforeSend: function() {
                $(rewards_input).attr('disabled', true);
            },
            success: function(response) {
                $(rewards_input).attr('disabled', false);
                $('div.modal').addClass('hide');
                if (response.success) {
                    $(rewards_input).prop('checked', false);
                }
            }
        });
    }

    /* MODALS */
    function reorderModal(order) {
        reorder = order;
        let text = '';
        if (['Packing','Processing','Submitted'].includes(order.status)) {
            text = `This order is yet to be delivered.<br><br>
If you wish to Add to ${order.status === 'Packing' ? '(or Edit) ' : ''}this order click on 'Edit Order'.<br><br>
Or click 'Reorder' to create a new order based on this previous order. Please note that items currently in your box will be added to this order as well.<br><br>`;
            $(modal_reorder).find('button.btn-1').removeClass('hide').html('Edit Order').attr('data-action', 'edit');
            $(modal_reorder).find('button.btn-2').removeClass('hide').html('Reorder').attr('data-action', 'reorder');
        } else {
            text = `Click 'Reorder' to add the items from this previous order into your box.<br><br>Please note that items currently in your box will be added to this order as well.<br><br>`;
            $(modal_reorder).find('button.btn-1').removeClass('hide').html('Reorder').attr('data-action', 'reorder');
            $(modal_reorder).find('button.btn-2').addClass('hide').html('').attr('data-action', '');
        }
        $(modal_reorder).find('p.modal-content').html(text);
        $(modal_reorder).removeClass('hide')
    }

    function reorderCreate(action) {
        if (action === 'reorder') {
            location.href = `index.php?route=account/order/reorder&order_id=${reorder.id}`;
        } else if (action === 'edit') {
            order = { id: reorder.id, cart: 0, type: 'order' };
            editOrderUrl();
        }
    }

    function modalATCOpen(source) {
        from = source;
        $(modal_add).removeClass('hide');
    }

    function modalATC(el) {
        const action = parseInt($(el).attr('data-action'));
        $.ajax({
            url: dsUtilities.urlAccount() + '/add_to_cart',
            type: 'post',
            data: { action : action, from : from },
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    if (from === 'checkout' && action === 2) {
                        $(modal_add).addClass('hide');
                    } else {
                        location.href = response.url;
                    }
                }
            }
        });
    }

    function modalDeleteAccount() {
        $('div.modal[data-type="delete-account"]').removeClass('hide');
    }

    $(document).ready(function () {

        /* ADDRESS */
        $(address_form + ' input#firstname').focus();

        $(address_form + ' input#manual').on('change', function () {
            showAddressForm($(this).is(':checked'))
        });

        $(address_type).on('change', function () {
            changeAddressType($(this).val());
        });

        $(address_form + ' button#address_save').on('click', function() {
            validateAddress();
        });

        $(address_list + ' button#add-address').on('click', function () {
            location.href = dsUtilities.urlAddress() + '/insert';
        });

        $(address_list + ' a.delete-address').on('click', function () {
            deleteAddress($(this));
        });

        $(address_list + ' a.default-address').on('click', function () {
            defaultAddress($(this));
        });

        $(knock_sms).on('click', function () {
            if ($(this).attr('readonly') !== undefined) {
                $('span#' + $(this).attr('id') + '-msg').html('Not available for your address');
                return false;
            }
        });

        $(address_form + ' input#suburb, ' + address_form + ' input#postcode').autocomplete(suburbSearch());

        /* LOGIN */
        $('button#login_create').on('click', function() {
            location.href = 'index.php?route=account/register';
        });

        $(login_form + ' input').keydown(function(e) {
            if (e.keyCode === 13) {
                $(login_form).submit();
            }
        });

        /* FORGOTTEN PASSWORD */
        $('button#forgotten_login').on('click', function() {
            location.href = 'index.php?route=account/login';
        });

        /* ACTIVE ORDERS */
        $('a.link_reorder').on('click', function () {
            reorderModal(doorstep.orders[dsUtilities.getId(this)]);
        });

        $(modal_reorder + ' button.modal-btn-edit').on('click', function () {
            reorderCreate($(this).attr('data-action'));
        });

        $(`${order_history_div} a.link_cancel`).on('click', function () {
            order = getOrderHistoryData(this);
            $(modal_cancel).removeClass('hide');
        });

        $(`${order_history_div} a.link_edit`).on('click', function () {
            order = getOrderHistoryData(this);
            if (order.type === 'recurring' || (!order.transit && (order.add || order.edit))) {
                if (!doorstep.cart_count) {
                    editOrderUrl();
                } else {
                    $(modal_edit).removeClass('hide');
                }
            }
        });

        $('button.modal-btn-edit').on('click', function (e) {
            e.preventDefault();
            editOrderUrl(parseInt($(this).attr('data-cart')));
        });

        $('button.modal-btn-cancel').on('click', function (e) {
            e.preventDefault();
            if (order.id > 0) {
                location.href = dsUtilities.urlEdit() + `/cancelorder&order_id=${order.id}`;
            }
        });

        $('img.info-add-to-box').on('click', function () {
            addToCart(this);
        });

        $('img.info-fave').off('click').on('click', function () {
            addFavourite(this);
        });

        $('img.info-add-to-list').on('click', function () {
            addToList(this);
        });

        /* SHOPPING LISTS */
        $(list_edit).on('click', function () {
            listEdit()
        });

        $(list_done).on('click', function () {
            listDone();
        });

        $('img.shop-list-remove').on('click', function () {
            listItemRemove($(this));
        });

        /* BILLING */
        $('a#invoice_email').on('click', function (e) {
            e.preventDefault();
            invoiceEmail($(this))
        });

        /* REWARDS */
        $('input#rewards').on('change click', function (e) {
            e.preventDefault();
            rewardModal();
        });

        $('button#rewards-enrol').on('click', function () {
            rewardsEnrol();
        });

        $('button#rewards-resign').on('click', function () {
            rewardsResign();
        });

        /* GIFT VOUCHER */
        $(`${voucher_form} textarea#message`).on('mouseup', function () {
            $(this).select();
        });

        /* FREE DELIVERY */
        $(`${fd_form} select#plan`).on('change', function () {
            $(`${fd_form} input#amount`).val(this.value);
        });

        /* MODALS */
        $('button.account-close, img.close-modal').on('click', function (e) {
            e.preventDefault();
            $(this).closest('div.modal').addClass('hide');
        });

        $(`${modal_add} button.modal-btn-add`).on('click', function () {
            modalATC($(this));
        });

        /* ACCOUNT SETTINGS */
        $('button#referral_btn').on('click', function (e) {
            sendReferralEmail();
        });

        $('button#delete_account_btn').on('click', function () {
            modalDeleteAccount();
        });

        $('button#delete-account').on('click', function () {
            deleteAccount();
        });

    });

    return {
        setAddress        : setAddress,
        setSavedAddress   : setSavedAddress,
        getSavedAddress   : getSavedAddress,
        showAddressForm   : showAddressForm,
        changeAddressType : changeAddressType,
        setMessage        : setMessage,
        modalATCOpen      : modalATCOpen,
        gvValidate        : gvValidate,
        fdValidate        : fdValidate
    }

})(jQuery);